import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import AddQuoteForm from "layouts/library/quote-list/components/AddQuoteForm";

const AddQuotePopup = ({ open, close }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiPaper-root": {
          width: 350,
          height: 350,
          overflowX: "hidden",
        },
      }}
      onClose={() => {
        close(false);
      }}
    >
      <Box
        role="presentation"
        // onClick={() => { close(false) }}
      >
        <AddQuoteForm showAsPopup={close} />
      </Box>
    </Drawer>
  );
};

export default AddQuotePopup;
